/**
 * Ruft worker für alle items auf, höchstens limit gleichzeitig. Liefert wie
 * Promise.allSettled ein Ergebnis je item in derselben Reihenfolge, ein
 * Fehler hält die übrigen nicht auf. onSettled meldet den Fortschritt.
 *
 * @template T, R
 * @param {T[]} items
 * @param {number} limit
 * @param {(item: T, index: number) => Promise<R>} worker
 * @param {{ onSettled?: (done: number, total: number) => void }} [options]
 * @returns {Promise<({ status: 'fulfilled', value: R } |
 *   { status: 'rejected', reason: unknown })[]>}
 */
export const runWithConcurrency = async (
  items,
  limit,
  worker,
  { onSettled } = {}
) => {
  const results = new Array(items.length)
  let next = 0
  let done = 0

  const run = async () => {
    while (next < items.length) {
      const index = next
      next += 1

      try {
        results[index] = {
          status: 'fulfilled',
          value: await worker(items[index], index)
        }
      } catch (reason) {
        results[index] = { status: 'rejected', reason }
      }

      done += 1
      onSettled?.(done, items.length)
    }
  }

  const lanes = Math.max(1, Math.min(limit, items.length))
  await Promise.all(Array.from({ length: lanes }, run))

  return results
}
